//export const HTTPURL = 'http://13.200.114.252:4040/';
// export const HTTPURL = 'https://cs-api.kindlebit.com/';
export const HTTPURL = 'https://api.connectedschool.com.au/';
//export const HTTPURL = 'http://localhost:4040/';